import styles from '@ui/components/Voting/Voting.module.scss';
import {
  RaffleForm,
  RaffleFinal,
} from '@ui/components/Voting/components/Raffle/Raffle';
import Card from '@ui/components/Card/Card';
import CardBody from '@ui/components/Card/components/CardBody/CardBody';
import Slider from '@ui/components/Voting/components/Slider/Slider';
import Toggle from '@ui/components/Voting/components/Toggle/Toggle';
import VotingList from '@ui/components/Voting/components/VotingList/VotingList';
import IntroImage from '@ui/components/Voting/components/IntroImage/IntroImage';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const VotingTypeDecider = ({ votingType, ...props }) => {
  switch (votingType) {
    case 'slider':
      return <Slider {...props} />;
    case 'toggle':
      return <Toggle {...props} />;
    case 'list':
      return <VotingList {...props} />;
    default:
      return null;
  }
};

VotingTypeDecider.propTypes = {
  votingType: PropTypes.string.isRequired,
};

const Voting = ({
  headingLevel = 3,
  finalContent = null,
  finalLink = null,
  finalSubtitle = null,
  finalTitle = null,
  introImages,
  legalLabel = null,
  legalText = null,
  formContent,
  raffleContent = null,
  raffleTitle = null,
  step,
  store,
  ...props
}) => (
  <Card className={classNames(styles.container, 'fade-in-animation')}>
    <IntroImage images={introImages || []} />
    <CardBody className={styles.content}>
      {step === 0 && <VotingTypeDecider {...props} />}
      {step === 1 && (
        <RaffleForm
          formContent={formContent}
          headingLevel={headingLevel}
          legalLabel={legalLabel}
          legalText={legalText}
          raffleContent={raffleContent}
          raffleTitle={raffleTitle}
          store={store}
        />
      )}
      {step === 2 && (
        <RaffleFinal
          finalContent={finalContent}
          finalLink={finalLink}
          finalSubtitle={finalSubtitle}
          finalTitle={finalTitle}
          headingLevel={headingLevel}
        />
      )}
    </CardBody>
  </Card>
);

Voting.propTypes = {
  finalContent: PropTypes.string,
  finalLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
  finalSubtitle: PropTypes.string,
  finalTitle: PropTypes.string,
  headingLevel: PropTypes.number,
  /* eslint-disable-next-line */
  introImages: PropTypes.arrayOf(PropTypes.object),
  legalLabel: PropTypes.string,
  legalText: PropTypes.string,
  raffleContent: PropTypes.string,
  raffleTitle: PropTypes.string,
  step: PropTypes.number.isRequired,
  /* eslint-disable react/forbid-prop-types */
  /** `useFormStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  votingType: PropTypes.oneOf(['slider', 'toggle', 'list']).isRequired,
};

export default Voting;
